import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'common/utils/with-router';
import {parse, stringify} from 'query-string';
import {fetchReportPreviewAction} from 'common/actions/report-preview-actions';
import ReportForm from 'common/components/report-form';
import ReportPreview from 'common/components/report-preview';
import Api from 'common/middleware/api';
import './index.scss';

export class AppContainer extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    enums: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    navigate: PropTypes.func.isRequired,
    report: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired,
    view: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    Api.CSRF = props.settings.csrf;
    Api.HOST = props.settings.hosts.api;
    Api.WWW = props.settings.hosts.www;

    this.handleFormChange = this.handleFormChange.bind(this);
    this.handleFormUpdate = this.handleFormUpdate.bind(this);
  }

  componentDidMount() {
    this.fetchReportPreview(this.props.location, this.props.route.reportType);
  }

  fetchReportPreview(location, reportType) {
    this.props.dispatch(
      fetchReportPreviewAction(stringify(location.search), reportType),
    );
  }

  pushQueryToHistory(params) {
    // Don't put the csrf token on the url:
    const query = {...params};
    delete query.csrfmiddlewaretoken;
    this.props.navigate({
      pathname: this.props.location.pathname,
      search: stringify(query),
    });
  }

  render() {
    return (
      <div className={'AppContainer'}>
        <ReportForm
          handleChange={this.handleFormChange}
          handleUpdate={this.handleFormUpdate}
          hiddenFields={this.props.route.hiddenFields}
          report={this.props.report}
        />
        <ReportPreview
          loading={this.props.report.loading}
          report={this.props.report}
          view={this.props.route.view}
        />
      </div>
    );
  }

  handleFormChange(params) {
    this.fetchReportPreview(parse(params), this.props.route.reportType);
  }

  handleFormUpdate(params) {
    this.pushQueryToHistory(parse(params));
  }
}

const mapStateToProps = (state) => ({
  enums: state.enums,
  report: state.report,
  settings: state.settings,
});

export default connect(mapStateToProps)(withRouter(AppContainer));
